import React from "react";
import { formatLogin } from "../utils/shell";

// What a terminal shows of its shell (hooks/useShell.js): the login line, each command at the
// prompt it was typed at with what it printed, then the line being typed, with a block cursor and
// the gray suggestion, and Tab's choices under it. `Prompt` draws the window's prompt from { cwd,
// status }; `prefix` names the window's classes ("gh" gives gh-line, gh-cursor...).

const Piece = ({ piece, prefix }) => {
  if (typeof piece === "string") return piece;
  const className = piece.tone ? `${prefix}-${piece.tone}` : undefined;
  return piece.href ? (
    <a href={piece.href} target="_blank" rel="noopener noreferrer" className={`${prefix}-link ${className || ""}`}>
      {piece.text}
    </a>
  ) : (
    <span className={className}>{piece.text}</span>
  );
};

const Line = ({ line, prefix }) => (
  <div className={`${prefix}-line`}>
    {typeof line === "string" ? line : line.map((piece, i) => <Piece key={i} piece={piece} prefix={prefix} />)}
  </div>
);

const ShellLines = ({ shell, Prompt, prefix, tty }) => {
  const { session, input, caret, ghost, options, focused } = shell;
  if (!session) return null;
  const at = input[caret] || ghost[0] || " ";
  return (
    <div ref={shell.contentRef}>
      <div aria-live="polite">
        {session.blocks.map((b) =>
          b.login ? (
            <Line key={b.id} line={`Last login: ${formatLogin(b.login)} on ${tty}`} prefix={prefix} />
          ) : (
            <React.Fragment key={b.id}>
              <div className={`${prefix}-line`}>
                <Prompt cwd={b.cwd} status={b.status} /> {b.text}
              </div>
              {b.lines.map((line, i) => (
                <Line key={i} line={line} prefix={prefix} />
              ))}
            </React.Fragment>
          ),
        )}
      </div>
      <div className={`${prefix}-line ${prefix}-input-line`}>
        <Prompt cwd={session.cwd} status={session.status} /> <span>{input.slice(0, caret)}</span>
        <span
          key={`${input}:${caret}`}
          className={`${prefix}-cursor ${focused ? "" : "is-hollow"} ${input[caret] ? "" : "is-ghost"}`}
        >
          {at}
        </span>
        <span>{input.slice(caret + 1)}</span>
        {ghost && <span className={`${prefix}-ghost`}>{ghost.slice(1)}</span>}
        <input className={`${prefix}-field`} {...shell.fieldProps} />
      </div>
      {options.length > 0 && <Line line={options.flatMap((o, i) => (i ? ["  ", o] : [o]))} prefix={prefix} />}
    </div>
  );
};

export default ShellLines;
